import { render, staticRenderFns } from "./ShipmentGrid.vue?vue&type=template&id=0ad80da2&scoped=true&"
import script from "./ShipmentGrid.vue?vue&type=script&lang=ts&"
export * from "./ShipmentGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentGrid.vue?vue&type=style&index=0&id=0ad80da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad80da2",
  null
  
)

export default component.exports